module.exports = __webpack_public_path__ + "img/14-getting-there.81400840.png";